import { useAuthStore } from "~/stores/auth";

export default defineNuxtRouteMiddleware(async (to) => {
    const authStore = useAuthStore();
    const user = authStore.getUser;
    const isDealer = user?.PortalType === 'dealer';
    const code = (to.query.code as string) || null;
    const publicPages = ["/error", "/expired", "/signed-out"];
    const environments = ["development", "testing"];

    // Allow access to public pages
    if (publicPages.includes(to.path)) {
        return;
    }

    if (to.path == "/" && code) {
        return;
    }

    let checkAuth = true;

    if (environments.includes(process.env.NODE_ENV) && useRuntimeConfig().public.skipAuth === true) {
        checkAuth = false;
    }

    // Check if user is authenticated
    if (checkAuth) {
        if (authStore.isLoginExpired()) {
            const loginStatus = await authStore.refreshLogin();
            if (!loginStatus) {
                if (to.path !== "/") {
                    return navigateTo("/expired");
                } else {
                    return;
                }
            }
        }
    }

    if (to.path == "/") {
        if (isDealer) {
            return navigateTo("/dealer/dashboard");
        }

        return navigateTo("/dashboard");
    }
});
